export default "__VITE_ASSET__Bh6b1mnB__"